import PropTypes from 'prop-types';

import Card from 'honeydew/Card';
import { ChangePlanIcon } from 'honeydew/icons/MyPlan';
import Tag from 'honeydew/Tag';
import List from 'shared/List';
import { capitalize } from 'utils/globalUtils';

function FlexPlanInformation({ account, success }) {
    const { cartMinimum, deliveryDay } = account ?? {};
    const newUserDowngrade = success === 'downgrade';

    const flexPlanListItems = [
        {
            id: 1,
            text: `${capitalize(deliveryDay)} Delivery`,
        },
        {
            id: 2,
            text: 'No checkout needed',
        },
        {
            id: 3,
            text: `$${cartMinimum} order minimum`,
        },
        {
            id: 4,
            text: 'Weekly shopping reminder emails',
        },
        {
            id: 5,
            text: 'Access to our full assortment',
        },
        {
            id: 6,
            text: 'Loyalty points at 1X per dollar',
        },
    ];
    return (
        <Card>
            <div className="grow gap-70 md:flex">
                <h2 className="text-body-lg mb-20 font-grotesk-bold md:min-w-[180px]">Flex Plan</h2>

                <div>
                    <div className="rounded-md bg-off-white px-20 py-15 md:px-30 md:py-20">
                        <div className="grid grid-cols-[50px_1fr] items-start gap-20 md:grid-cols-[60px_1fr] md:gap-30">
                            <ChangePlanIcon />

                            <div className="flex flex-col items-start">
                                {newUserDowngrade && (
                                    <Tag bgColor="lime" variant="dark">
                                        YOUR NEW FLEX PLAN!
                                    </Tag>
                                )}
                                <p className="my-5 font-grotesk-bold">Shop without a subscription</p>
                                <p className="text-body-sm">
                                    Fridge looking empty? Log in during your shopping window to build your cart from
                                    scratch.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="mt-20">
                        {newUserDowngrade && <p className="mb-10 font-grotesk-bold">You&apos;ll still enjoy:</p>}
                        <div className="text-body-sm">
                            <List listItems={flexPlanListItems} />
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
}

FlexPlanInformation.propTypes = {
    account: PropTypes.shape({}),
};

FlexPlanInformation.defaultProps = {
    account: {},
};

export default FlexPlanInformation;
